import React from "react";
import "./Private5G.css";

const Private5G = () => {
  return (
    <>
      {/* HERO SECTION - SAME SIZE AS OTHER PAGES */}
      <section
        className="container-fluid page-header py-5 mb-5 wow fadeIn"
        data-wow-delay="0.1s"
        style={{
          background:
            "linear-gradient(rgba(8,28,69,0.75), rgba(8,28,69,0.75)), url('assets/img/private5g4.png') center center / cover no-repeat"
        }}
      >
        <div className="container py-5">
          <h1 className="display-3 text-white text-center mb-3 animated slideInDown">
            Private 5G Solutions
          </h1>

          {/* <p className="text-white private-hero-text">
            Enabling secure, scalable, and intelligent
            wireless infrastructure for Industry 4.0,
            Industrial IoT, AI-driven operations,
            and enterprise digital transformation.
          </p> */}
        </div>
      </section>

      {/* SECTION 1 */}
      <section className="py-5">
        <div className="container">

          <div className="row align-items-center g-5">

            {/* LEFT CONTENT */}
            <div className="col-lg-6">

              <span className="private-tag">
                Enterprise Connectivity
              </span>

              <h2 style={{color: "#021bf5"}} className="private-title mt-3">
                Transforming Industries with
                Private 5G Connectivity
              </h2>

              <p className="private-text">
                As organizations accelerate digital transformation, traditional wireless networks are 
                struggling to support the demands of Industry 4.0, Industrial IoT (IIoT), AI-driven operations, 
                and edge computing. Private 5G connectivity is emerging as a powerful solution that delivers secure, 
                high-performance, and scalable wireless infrastructure for modern enterprises.
              </p>

              <p className="private-text">
                Unlike conventional WiFi or public cellular networks, Private 5G provides dedicated connectivity 
                with greater control, enhanced security, ultra-low latency, and reliable coverage. 
                This enables organizations to support mission-critical applications, 
                automate operations, and improve decision-making through real-time data access.
              </p>

              <p className="private-text">
                At Celersoft, we help enterprises deploy and optimize Private 5G solutions that drive 
                operational efficiency, 
                business agility, and long-term digital transformation.
              </p>

            </div>

            {/* RIGHT IMAGE */}
            <div className="col-lg-6">
              <div className="image-wrapper">
                <img
                  src="assets/img/private5G.png"
                  alt="Private 5G"
                  className="img-fluid rounded-4 shadow"
                />
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* CORE ADVANTAGES */}
      <section className="py-5 private-gradient-section">
        <div className="container">

          <div className="text-center mb-5">
            <span className="private-tag">
              Business Value
            </span>

            <h2 className="private-title mt-2">
              Core Advantages Driving Adoption
            </h2>
          </div>

<div className="row mb-5">
  <div className="col-12">

    <div className="private-banner-image">

      <img
        src="assets/img/private5g1.png"
        alt="Private 5G Advantages"
        className="img-fluid w-100"
      />

    </div>

  </div>
</div>



          <div className="row g-4">

            <div className="col-lg-4">
              <div className="advantage-card">

                <div className="advantage-icon">
                  ⚡
                </div>

                <h4>Superior Performance</h4>

                <p>
                  Ultra-low latency, high bandwidth,
                  and reliable connectivity to support
                  industrial automation, autonomous
                  systems, and real-time analytics.
                </p>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="advantage-card">

                <div className="advantage-icon">
                  🔒
                </div>

                <h4>Enhanced Security</h4>

                <p>
                  Enterprise-grade encryption,
                  network isolation, secure
                  authentication, and centralized
                  management for mission-critical systems.
                </p>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="advantage-card">

                <div className="advantage-icon">
                  ⚙️
                </div>

                <h4>Full Customization</h4>

                <p>
                  Tailor coverage, capacity,
                  security policies, and performance
                  to meet business objectives
                  and future growth.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* BEYOND WIFI */}
      <section className="py-5">
        <div className="container">

          <div className="row align-items-center g-5">

            <div className="col-lg-6">

  <div className="comparison-card">

    <div className="comparison-header">
      <h3>WiFi vs Private 5G</h3>
      <p>
        See why enterprises are moving beyond
        traditional wireless infrastructure.
      </p>
    </div>

    <div className="comparison-table">

      <div className="comparison-row comparison-title">
        <div>Capability</div>
        <div>WiFi</div>
        <div>Private 5G</div>
      </div>

      <div className="comparison-row">
        <div>Latency</div>
        <div>High</div>
        <div>Ultra-Low</div>
      </div>

      <div className="comparison-row">
        <div>Coverage</div>
        <div>Limited</div>
        <div>Wide Area</div>
      </div>

      <div className="comparison-row">
        <div>Security</div>
        <div>Shared</div>
        <div>Dedicated</div>
      </div>

      <div className="comparison-row">
        <div>Mobility</div>
        <div>Moderate</div>
        <div>Seamless</div>
      </div>

      <div className="comparison-row">
        <div>IoT Scale</div>
        <div>Medium</div>
        <div>Massive</div>
      </div>

      <div className="comparison-row">
        <div>Reliability</div>
        <div>Variable</div>
        <div>Enterprise Grade</div>
      </div>

    </div>

  </div>

</div>

            <div className="col-lg-6">

              <span className="private-tag">
                Enterprise Advantage
              </span>

              <h2 className="private-title mt-2">
                Beyond WiFi: The Enterprise
                5G Advantage
              </h2>

              <div className="benefits-list">

                <div>✓ Ultra-low latency communications</div>
                <div>✓ High-speed wireless connectivity</div>
                <div>✓ Reliable mission-critical operations</div>
                <div>✓ Enhanced cybersecurity</div>
                <div>✓ Seamless mobility</div>
                <div>✓ Large-scale Industrial IoT support</div>
                <div>✓ Scalable infrastructure</div>

              </div>

              

            </div>

          </div>
        </div>
      </section>

      {/* USE CASES */}
      <section className="py-5 bg-light">
        <div className="container">

          <div className="text-center mb-5">
            <span className="private-tag">
              Industry Applications
            </span>

            <h2 className="private-title mt-2">
              Activating the Industry Edge:
              High-Impact Use Cases
            </h2>
          </div>

          <div className="row g-4">

            <div className="col-lg-4">
              <div className="use-case-card h-100">

  <img
    src="assets/img/private5g1.jpg"
    alt=""
    className="use-case-img"
  />

  <div className="p-4">

    <h4>
      Smart Manufacturing & Logistics
    </h4>

    <p>
      Enable connected factories, industrial automation, predictive maintenance, 
      automated guided vehicles, real-time asset tracking, and intelligent supply chain operations.
    </p>

  </div>

</div>
            </div>

            <div className="col-lg-4">
              <div className="use-case-card h-100">
                <img
    src="assets/img/private5g2.jpg"
    alt=""
    className="use-case-img"
  />

  <div className="p-4">
                <h4>Remote Mining & Port Operations</h4>

                <p>
                  Support autonomous equipment, workforce communications, remote monitoring, 
                  predictive maintenance, and operational visibility across large industrial environments.
                </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="use-case-card h-100">
                <img
    src="assets/img/private5g3.jpg"
    alt=""
    className="use-case-img"
  />

  <div className="p-4">
                <h4>Healthcare & Campus Security</h4>

                <p>
                  Power telemedicine, connected medical devices, remote patient monitoring, smart surveillance, access control, 
                  and emergency communication systems through secure, high-performance connectivity.
                </p>
                </div>
              </div>
            </div>

          </div>

        </div>
      </section>

      {/* CTA */}
      <section style={{
    background:
      "url('assets/img/private5g_background.png') center/cover no-repeat"
  }} className="private-cta py-5">
        <div className="container text-center text-white">

          <h2 className="fw-bold text-white">
            Deploy Your Dedicated Network Today
          </h2>

          <p className="mt-3">
            Private 5G is transforming how organizations connect, operate, and innovate. By delivering secure, 
            scalable, and high-performance wireless infrastructure, businesses can accelerate digital transformation 
            while improving operational efficiency and resilience.
          </p>

        </div>
      </section>

      {/* PARTNER */}
      <section className="py-5">
        <div className="container">

  <div className="row align-items-center g-5">

    <div className="col-lg-5">

      <img
        src="assets/img/partner.png"
        alt="Partnership"
        className="img-fluid rounded-4 shadow"
        style={{
                    width: "100%",
                    height: "300px",
                    objectFit: "cover",
                    borderRadius: 24
                  }}
      />

    </div>

    <div className="col-lg-7">

      <span className="private-tag">
        Partner with Celersoft
      </span>

      <h2 className="private-title mt-2">
        Build Future-Ready Connectivity
      </h2>

      <p className="private-text">
        Celersoft provides end-to-end Private 5G services and solutions, from network design and
         deployment to integration and ongoing support. Our experts help organizations build 
         future-ready connectivity platforms that enable smarter operations, stronger security,
         and sustainable business growth.
      </p>

    </div>

  </div>

</div>
      </section>

      {/* Footer Start */}
      <div className="container-fluid footer wow fadeIn" data-wow-delay="0.2s">
        <div className="container pt-4">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p>
                <span style={{ fontSize: 20 }}>
                  <em>
                    <strong>USA</strong>
                  </em>
                </span>
              </p>
              <p>
                <i className="fas fa-map-marker me-1" />1500 S Dairy Ashford Rd
                <br />
                Ste 355 Houston
                <br />
                TX 77077
              </p>
            </div>

            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="single_address">
                <p>
                  <em>
                    <span style={{ fontSize: 20 }}>
                      <strong>CANADA</strong>
                    </span>
                  </em>
                </p>
                <p>
                  <i className="fas fa-map-marker me-1" /> 998 Loft Court,
                  <br />
                  London, Ontario
                  <br />
                  N6G0J9
                </p>
              </div>
            </div>

            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="single_address">
                <p>
                  <span style={{ fontSize: 20 }}>
                    <em>
                      <strong>INDIA</strong>
                    </em>
                  </span>
                </p>
                <p>
                  <i className="fas fa-map-marker me-1" /> D. No. 38, 2nd Floor,
                  <br />
                  Arjun Plaza, SP Road,
                  <br />
                  Nizampet, Hyderabad,
                  <br />
                  Telangana - 500085
                </p>
              </div>
            </div>

            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <a href="mailto:info@celersoft.com">
                  <i className="fas fa-envelope me-2" /> info@celersoft.com
                </a>
                <a href="tel:+18322258898">
                  <i className="fas fa-phone me-2" /> (+1) 832-225-8898
                </a>
                <hr />
                <div className="d-flex align-items-center">
                  <a
                    className="btn btn-light btn-md-square me-2"
                    href="https://www.facebook.com/celersoft"
                  >
                    <i className="fab fa-facebook-f" />
                  </a>
                  <a
                    className="btn btn-light btn-md-square me-0"
                    href="https://www.linkedin.com/company/celersoft/"
                  >
                    <i className="fab fa-linkedin-in" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid copyright py-3">
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-md-6 text-center text-md-start mb-md-0">
              <span className="text-body">
                <i className="fas fa-copyright text-light me-1" />
                2024 Celersoft. All rights reserved.
              </span>
            </div>
            <div className="col-md-6 text-center text-md-end text-body">
              {/* <a
                className="border-bottom text-primary"
                href="https://htmlcodex.com"
              >
                HTML Codex
              </a>{" "}
              Distributed By{" "}
              <a
                className="border-bottom text-primary"
                href="https://themewagon.com"
              >
                ThemeWagon
              </a> */}
            </div>
          </div>
        </div>
      </div>

      <button
        className="btn btn-primary btn-lg-square back-to-top"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        <i className="fa fa-arrow-up" />
      </button>
      {/* Footer End */}
    </>
  );
};

export default Private5G;